import { Action, createReducer, on } from '@ngrx/store';
import { ViewColActions } from '../actions';
import { ViewColumnState, initialState } from '../states/view-col.states';

export const viewColReducer = createReducer(
  initialState,
  on(ViewColActions.viewColNext, (state, action) => {
    switch (state.singleColumn) {
      case true:
          state.leftDrawer.push(state.firstColumn);
          state.prevIndex = state.firstColumn.index;
          state.firstColumn = state.viewCol[action.index];
          state.breadCrumbs.push(state.viewCol[action.index]);
      break;
      default:
          if (!state.secondColumn) {
            state.prevIndex = state.firstColumn.index;
            state.secondColumn = state.viewCol[action.index];
            state.breadCrumbs.push(state.viewCol[action.index]);
          } else {
              state.prevIndex = state.secondColumn.index;
              state.leftDrawer.push(state.firstColumn);
              state.firstColumn = state.viewCol[state.secondColumn.index];
              state.secondColumn = state.viewCol[action.index];
              state.breadCrumbs.push(state.viewCol[action.index]);
          }
      break;
    }
    return state;
  }),
  on(ViewColActions.viewColNextAndReset, (state, action) => {
    let pivotIndex = 0;
    const temp = [...state.breadCrumbs];
    state.rightDrawer = [];
    state.breadCrumbs.forEach( (crumb, i) => {
      if (crumb.index === action.curIndex)  {
        pivotIndex = i;
      }
    });
    temp.forEach( (crumb, i) => {
      if ( i > pivotIndex)  {
        const resetState = state.viewCol[crumb.index].localState;
        const keyVal = Object.entries(resetState);
        keyVal.forEach(([k, v]) => {
          if (typeof(v) === 'boolean') {
            resetState[k] = false;
          }
        })
      }
    });
    state.breadCrumbs.forEach((crumb, i) => {
      if (crumb.index === action.curIndex) {
        state.breadCrumbs.splice(i + 1);
      }
    });
    state.breadCrumbs.push(state.viewCol[action.nextIndex]);
    state.prevIndex = action.curIndex;
    switch (state.singleColumn) {
      case true:
        state.leftDrawer.push(state.firstColumn);
        state.firstColumn = state.viewCol[action.nextIndex];
      break;
      default:
        if (action.curIndex === state.firstColumn.index) {
          state.secondColumn = state.viewCol[action.nextIndex];
        } else {
          state.leftDrawer.push(state.firstColumn);
          state.firstColumn = state.viewCol[state.secondColumn.index];
          state.secondColumn = state.viewCol[action.nextIndex];
        }
      break;
    }
    return state;
  }),
  on(ViewColActions.viewColNextAndReset2Column, (state, action) => {
    let pivotIndex = 0;
    const temp = [...state.breadCrumbs];
    state.rightDrawer = [];
    state.breadCrumbs.forEach( (crumb, i) => {
      if (crumb.index === action.curIndex)  {
        pivotIndex = i;
      }
    });
    temp.forEach( (crumb, i) => {
      if ( i > pivotIndex)  {
        const resetState = state.viewCol[crumb.index].localState;
        const keyVal = Object.entries(resetState);
        keyVal.forEach(([k, v]) => {
          if (typeof(v) === 'boolean') {
            resetState[k] = false;
          }
        })
      }
    });
    state.breadCrumbs.forEach((crumb, i) => {
      if (crumb.index === action.curIndex) {
        state.breadCrumbs.splice(i + 1);
      }
    });
    state.leftDrawer = [];
    state.prevIndex = action.curIndex;
    state.leftDrawer.push(state.viewCol[action.curIndex]);
    state.firstColumn = state.viewCol[action.nextIndex1];
    state.secondColumn = state.viewCol[action.nextIndex2];
    return state;
  }),
  on(ViewColActions.viewColPrev, (state, action) => {
    switch (state.singleColumn) {
      case true:
        state.breadCrumbs.pop();
        state.leftDrawer.pop();
        state.firstColumn = state.viewCol[state.breadCrumbs[state.breadCrumbs.length - 1].index];
        state.prevIndex = state.breadCrumbs.length > 1 ? state.breadCrumbs[state.breadCrumbs.length - 2].index : 0;
      break;
      default:
          if (!state.leftDrawer.length) {
            state.prevIndex = 0;
            state.secondColumn = null;
          } else {
            state.secondColumn = state.viewCol[state.firstColumn.index];
            state.firstColumn = state.viewCol[state.leftDrawer.pop().index];
            state.prevIndex = state.firstColumn.index;
          }
          state.breadCrumbs.pop();
      break;
    }
    return state;
  }),
  on(ViewColActions.viewColRvIndex, (state, action) => {
    switch (state.singleColumn) {
      case true:
        state.rightDrawer.unshift(state.firstColumn);
        state.rightDrawer = state.leftDrawer.concat(state.rightDrawer);
        state.firstColumn = state.viewCol[action.index];
        state.leftDrawer.forEach( (col, i, cols) => {
          if (col.index === action.index) {
            state.leftDrawer.splice(i);
          }
        });
        state.rightDrawer.forEach((col, i, cols) => {
          if (col.index === action.index) {
            state.rightDrawer = cols.slice(i + 1);
          }
        });
      break;
      default:
        state.rightDrawer = [...state.leftDrawer, state.firstColumn, state.secondColumn, ...state.rightDrawer];
        state.firstColumn = state.viewCol[action.index];
        state.rightDrawer.forEach( (col, i, cols) => {
          if (col.index === action.index) {
            state.secondColumn = state.viewCol[cols[i + 1].index];
          }
        });
        state.leftDrawer.forEach( (col, i, cols) => {
          if (col.index === action.index) {
            state.leftDrawer.splice(i);
          }
        });
        state.rightDrawer.forEach((col, i, cols) => {
          if (col.index === action.index) {
            state.rightDrawer = cols.slice(i + 2);
          }
        });
      break;
    }
    return state;
  }),
  on(ViewColActions.viewColFwIndex, (state, action) => {
    switch (state.singleColumn) {
      case true:
        state.leftDrawer.push(state.firstColumn);
        state.leftDrawer = state.leftDrawer.concat(state.rightDrawer);
        state.firstColumn = state.viewCol[action.index];
        state.rightDrawer.forEach( (col, i, cols) => {
          if (col.index === action.index) {
            state.rightDrawer = cols.slice(i + 1);
          }
        });
        state.leftDrawer.forEach((col, i) => {
          if (col.index === action.index) {
            state.leftDrawer.splice(i);
          }
        });
      break;
      default:
        state.leftDrawer.push(state.firstColumn, state.secondColumn);
        state.leftDrawer = state.leftDrawer.concat(state.rightDrawer);
        state.secondColumn = state.viewCol[action.index];
        state.leftDrawer.forEach((col, i) => {
          if (col.index === action.index) {
            state.firstColumn = state.viewCol[state.leftDrawer[i - 1].index];
            state.leftDrawer.splice(i - 1);
          }
        });
        state.rightDrawer.forEach((col, i, cols) => {
          if (col.index === action.index) {
            state.rightDrawer = cols.slice(i + 1);
          }
        });
      break;
    }
    return state;
  }),
  on(ViewColActions.goToIndex, (state, action) => {
    switch (state.singleColumn) {
      case true:
        state.firstColumn = state.viewCol[action.index];
        state.leftDrawer.forEach((drawer, i) => {
          if (drawer.index === action.index) {
            state.leftDrawer.splice(i);
            state.rightDrawer = state.breadCrumbs.filter(crumb => !state.leftDrawer.includes(crumb) && crumb.index !== state.firstColumn.index);
          }
        });
        state.rightDrawer.forEach((drawer, i) => {
          if (drawer.index === action.index) {
            state.rightDrawer = state.rightDrawer.slice(i);
            state.leftDrawer = state.breadCrumbs.filter(crumb => !state.rightDrawer.includes(crumb) && crumb.index !== state.firstColumn.index);
          }
        });
      break;
      default:
        state.breadCrumbs.forEach((col, i, cols) => {
          if (col.index === action.index) {
            if (i === cols.length - 1) {
              state.secondColumn = state.viewCol[col.index];
              state.firstColumn = state.viewCol[cols[i - 1].index];
            } else {
              state.firstColumn = state.viewCol[col.index];
              state.secondColumn = state.viewCol[cols[i + 1].index];
            }
          }
        });
        state.leftDrawer.forEach((drawer, i) => {
          if (drawer.index === action.index) {
            state.leftDrawer.splice(i);
            state.rightDrawer = state.breadCrumbs.filter(crumb => !state.leftDrawer.includes(crumb) && crumb.index !== state.firstColumn.index && crumb.index !== state.secondColumn.index);
          }
        });
        state.rightDrawer.forEach((drawer, i) => {
          if (drawer.index === action.index) {
            state.rightDrawer = state.rightDrawer.slice(i + 1);
            state.leftDrawer = state.breadCrumbs.filter(crumb => !state.rightDrawer.includes(crumb) && crumb.index !== state.firstColumn.index && crumb.index !== state.secondColumn.index);
          }
        });
      break;
    }
    return state;
  }),
  on(ViewColActions.resetIndex, (state, action) => {
    let pivotIndex = 0;
    const temp = [...state.breadCrumbs];
    state.rightDrawer = [];
    state.breadCrumbs.forEach((crumb, i) => {
      if (crumb.index === action.index) {
        state.breadCrumbs.splice(i + 1);
        pivotIndex = i;
      }
    });
    temp.forEach((crumb, i) => {
      if (i >= pivotIndex) {
        const resetState = state.viewCol[crumb.index].localState;
        const keyVal = Object.entries(resetState);
        keyVal.forEach(([k, v]) => {
          if (typeof(v) === 'boolean') {
            resetState[k] = false;
          }
        })
      }
    });
    switch (state.singleColumn) {
      case true:
        state.firstColumn = state.viewCol[action.index];
        state.leftDrawer.forEach((col, i) => {
          if (col.index === action.index) {
            state.leftDrawer.splice(i);
          }
        });
        state.prevIndex = state.breadCrumbs.length > 1 ? state.breadCrumbs[state.breadCrumbs.length - 2].index : 0;
        break;
      default:
        state.leftDrawer = [];
        if (!action.index) {
          state.firstColumn = state.viewCol[action.index];
          state.secondColumn = null;
          state.prevIndex = 0;
        } else {
          temp.forEach((col, i, cols) => {
            if (col.index === action.index) {
              state.firstColumn = state.viewCol[cols[i - 1].index];
              state.secondColumn = state.viewCol[col.index];
            }
          });
          state.breadCrumbs.forEach(crumb => {
            if (crumb.index !== state.firstColumn.index && crumb.index !== state.secondColumn.index) {
              state.leftDrawer.push(crumb);
            }
          });
          state.prevIndex = state.firstColumn.index;
        }
        break;
    }
    return state;
  }),
  on(ViewColActions.toggleColumn, (state, action) => {
    switch (action.toggle) {
      case true:
        if (state.secondColumn) {
          state.rightDrawer.unshift(state.secondColumn);
          state.secondColumn = null;
        }
      break;
      default:
        if (!state.secondColumn) {
          state.secondColumn = state.rightDrawer.length ? state.viewCol[state.rightDrawer.shift().index] : null;
        }
        if (state.secondColumn && state.firstColumn.index === state.secondColumn.index) {
          state.breadCrumbs.forEach((crumb, i, crumbs) => {
            if (crumb.index === state.secondColumn.index) {
              state.firstColumn = state.viewCol[crumbs[i - 1].index];
            }
          });
          state.leftDrawer = state.leftDrawer.filter(drawer => drawer.index !== state.firstColumn.index);
        }
      break;
    }
    state.singleColumn = action.toggle;
    return state;
  }),
  on(ViewColActions.viewColUpdateInstance, (state, action) => {
    state.viewCol[action.index].localState = {...action.localState};
    return state;
  }),
  on(ViewColActions.setViewColState, (state, action) => {
    state = {...action.state, breadCrumbs: action.state.breadCrumbs.length ? action.state.breadCrumbs : [action.state.firstColumn] };
    return state;
  }),
  on(ViewColActions.updateViewColumnsLabels, (state, { updatedCols }) => ({
    ...state,
    viewCol: updatedCols
  })),

  on(ViewColActions.updateLeftDrawer, (state, { leftDrawer }) => ({
    ...state,
    leftDrawer: [...leftDrawer],
  })),

  on(ViewColActions.updateRightDrawer, (state, { rightDrawer }) => ({
    ...state,
    rightDrawer: [...rightDrawer],
  })),
  on(ViewColActions.updateBreadcrumbs, (state, { breadcrumbs }) => ({
    ...state,
    breadCrumbs: [...breadcrumbs]
  })),
);

export function reducer(state: ViewColumnState | undefined, action: Action) {
  return viewColReducer(state, action);
}

